var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Validera-konto-Copy-12",
    transform: "translate(-888.000000, -532.000000)",
    fill: "#F5B13E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(768.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.12,555.5 C138.94,555.5 139.62,556.165 139.62,556.993 L139.62,557.007 C139.62,557.835 138.94,558.507 138.12,558.507 C137.29,558.507 136.62,557.835 136.62,557.007 C136.62,556.178 137.29,555.5 138.12,555.5 Z M136.62,543.76 C136.62,542.932 137.29,542.26 138.12,542.26 C138.94,542.26 139.62,542.932 139.62,543.76 L139.62,551.676 C139.62,552.504 138.94,553.176 138.12,553.176 C137.29,553.176 136.62,552.504 136.62,551.676 L136.62,543.76 Z M153.23,562.725 C153.23,564.104 152.11,565.225 150.73,565.225 L125.5,565.225 C124.13,565.225 123,564.104 123,562.725 L123,537.5 C123,536.121 124.13,535 125.5,535 L150.73,535 C152.11,535 153.23,536.121 153.23,537.5 L153.23,562.725 Z M125.5,532 C122.47,532 120,534.467 120,537.5 L120,562.725 C120,565.757 122.47,568.225 125.5,568.225 L150.73,568.225 C153.76,568.225 156.23,565.757 156.23,562.725 L156.23,537.5 C156.23,534.467 153.76,532 150.73,532 L125.5,532 Z",
    id: "Warning"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4e6c56695ffb6ffc72ec50ec424a5ea0.svg";
export { ForwardRef as ReactComponent };